module.exports = __webpack_public_path__ + "static/img/preview.ac27c3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/dark-blue-banner-campaign/preview.png
// module id = 86
// module chunks = 2